@if (markets.length > 0) {
  <div class="header">
    <span class="title"> {{ headerTitle }} </span>
  </div>
    <select [disabled]="!leagues.length" [value]="selectedLeague" class="league-filter" (change)="handleLeagueFilter($event)">
        @for (league of leagues; track league.id) {
            <option [value]="league.id">{{ league.name }}</option>
        }
    </select>
  <div class="in-play-content">
    <table>
      <thead>
        <tr>
          <th>
            <div class="e-th">
              <span> {{ "Event" | translate }} </span>
              <button
                (click)="handleSort('eventName')"
                class="sort-btn"
                [matTooltip]="currentSort?.field === 'eventName' ? (currentSort?.order === 'asc' ? 'Sort descending' : 'Clear sorting') : 'Sort ascending'">
                <mat-icon>
                  {{ currentSort?.field === "eventName" ? (currentSort?.order === "asc" ? "keyboard_arrow_up" : "close") : "unfold_more" }}
                </mat-icon>
              </button>
            </div>
          </th>
          <th>
            <div class="matched-th">
              <span> {{ "Matched" | translate }} </span>
              <button
                (click)="handleSort('totalMatched')"
                class="sort-btn"
                [matTooltip]="currentSort?.field === 'totalMatched' ? (currentSort?.order === 'asc' ? 'Sort descending' : 'Clear sorting') : 'Sort ascending'">
                <mat-icon>
                  {{ currentSort?.field === "totalMatched" ? (currentSort?.order === "asc" ? "keyboard_arrow_up" : "close") : "unfold_more" }}
                </mat-icon>
              </button>
            </div>
          </th>
          @for (item of tHeaders; track item) {
            <th colspan="2">{{ item | translate }}</th>
          }
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (item of markets; track item) {
          <tr app-h-row [market]="item"></tr>
        }
      </tbody>
    </table>
  </div>
}
